import React from 'react'
import Button from '../components/Button'
import Spline from '@splinetool/react-spline';
import ScrollStackAnimation from '../components/ScrollStackAnimation';
import { useServiceData } from '../context/ServiceDataContext';
import ServicesShowcase from '../components/ServicesShowcase';
import { Link } from 'react-router-dom';










const TailorMadeCard = ({ data }) => (
    <div className="dark:text-white flex flex-col pt-15 w-full relative gap-5">
        <div className="flex items-center justify-center mx-auto xl:mx-0 w-18 h-18">
            <img src={data.src} className='h-full object-contain' alt="" />
        </div>
        <div className='xl:w-[calc(100%-4rem)]'>
            <div className="text-2xl font-bold leading-tight ">{data.heading}</div>
            <p className="dark:text-gray-300 text-zinc-800 mt-3 xl:w-[80%] text-md font-medium">
                {data.p}
            </p>
        </div>
    </div>
);




const cardData = [
    {
        heading: "Social Media Management",
        p: `We create scroll-stopping content, manage your brand’s presence across platforms `,
        src: "/new-final-data/marketing/SMM.svg"
    },
    {
        heading: "Evergreen Strategy (Brand Bible)",
        p: `We craft a brand playbook that defines your voice, look and storytelling style so that your brand feels consistent`,
        src: "/new-final-data/marketing/ES.svg"
    },
    {
        heading: "Campaign-level Strategy",
        p: `From big launches to seasonal campaigns, we design strategies that grab attention, spark conversations and drive results`,
        src: "/new-final-data/marketing/CLS.svg"
    },
    {
        heading: "Search Engine Optimization (SEO)",
        p: `We optimize your website to rank higher, reach the right audience and stay ahead`,
        src: "/new-final-data/marketing/SEO.svg"
    },
]



const MarketingSection1 = () => {
    const { getServiceById, getServiceByCategory } = useServiceData();
    const marketingServices = getServiceByCategory(`marketing`);



    return (
        <>
            <div className='flex items-center text-center xl:text-left text-white bg-black flex-col-reverse xl:flex-row justify-between xl:gap-10 xl:px-35 pointer-events-auto'>
                <div className='h-fit xl:w-[50vw] space-y-5 xl:ml-10 py-20 xl:py-0 px-10 '>
                    <div className="">
                        <h3 className='text-sm text-zinc-500 font-semibold uppercase'>Digital Marketing</h3>
                        <h1 className="xl:text-6xl text-4xl font-bold xl:mt-2 capitalize ">
                            Marketing that makes heads turn.
                        </h1>
                    </div>
                    <div className="">
                        <p className="text-lg dark:text-zinc-200">
                            Leading digital marketing agency in the US, we dive deep into data to understand who your customers truly are by combining insights with creativity.
                        </p>
                    </div>
                    <Link to={"/contact"}>
                        <Button>Contact us</Button>
                    </Link>
                </div>
                <div className=" xl:w-fit w-full">
                    <div className="xl:h-screen h-[60vh] xl:w-[700px] relative hidden xl:block">
                        <Spline
                            className='scale-90'
                            scene="https://prod.spline.design/M3bKPgSV0boDFZpj/scene.splinecode"
                        />
                        <div className="absolute bottom-[7%] right-[7.5%] h-[40px] w-[150px] bg-black md:scale-[1.2] xl:scale-[1] "></div>

                    </div>

                    <div className=" h-screen w-full relative xl:hidden">
                        <img src="/new-final-data/marketing/marketing-landing.png" className='h-full w-full object-cover' alt="" />
                    </div>
                </div>
            </div>





            <ScrollStackAnimation />

            <div className='xl:px-35 px-10 grid md:grid-cols-2 text-center xl:text-left xl:grid-cols-4 xl:gap-2 xl:pt-10 pb-20'>
                {
                    cardData.map((card, index) => (
                        <TailorMadeCard key={index} data={card} />
                    ))
                }
            </div>
                <ServicesShowcase data={marketingServices} superData={marketingServices} />
        </>
    )
}

export default MarketingSection1